<div class="row justify-content-center">
    <div class="col-lg-8">
        <div *ngIf="user" class="card">
            <div class="card-body">
                <form [formGroup]="registerForm" (ngSubmit)="update()">
                    <div class="form-body">
                        <h3 class="card-title">Mis datos</h3>
                        <hr>
                        <div class="row p-t-20">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Nombre</label>
                                    <input formControlName="name" type="text"  class="form-control" placeholder="Nombre">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Apellido</label>
                                    <input formControlName="surname" type="text"  class="form-control" placeholder="Apellido">
                                </div>
                            </div>
                            <div *ngIf="user.role!='evaluated'" class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Alias</label>
                                    <input formControlName="alias" type="text"  class="form-control" placeholder="Alias">
                                </div>
                            </div>
                            <!--/span-->
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Email</label>
                                    <input [readOnly]="true" formControlName="email" type="email"  class="form-control" placeholder="Email">
                                </div>
                            </div>
                            <!--/span-->
                        </div>
                        <!--/row-->
                        <div class="row">
                            <div *ngIf="user.role=='admin'" class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Rol</label>
                                    <select formControlName="role" class="form-control custom-select">
                                        <option value="admin">admin</option>
                                        <option value="client">client</option>
                                        <option value="evaluated">evaluated</option>
                                    </select>
                                </div>
                            </div>


                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Teléfono</label>
                                    <input formControlName="phone" type="text" class="form-control" placeholder="Teléfono">
                                </div>
                            </div>
                            <div *ngIf="user.role=='client'" class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Profesión</label>
                                    <input formControlName="profession" type="text" class="form-control" placeholder="Profesión">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Empresa</label>
                                    <input formControlName="company" type="text" class="form-control" placeholder="Empresa">
                                </div>
                            </div>

                            <div *ngIf="user.role=='admin'" class="col-md-6">    
                                <div class="form-group">
                                    <label class="control-label">Notas</label>
                                    <input formControlName="notes" type="text" class="form-control" placeholder="Notas">
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">País</label>
                                    <input formControlName="country" type="text" class="form-control" placeholder="País">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Ciudad</label>
                                    <input formControlName="city" type="text" class="form-control" placeholder="Ciudad">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Sexo</label>
                                    <input formControlName="sex" type="text" class="form-control" placeholder="Sexo">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Fecha de nacimiento</label>
                                    <input formControlName="birthDate" type="date" class="form-control" placeholder="Fecha de nacimiento">
                                </div>
                            </div>
                            <div *ngIf="user.role!='evaluated'" class="col-md-6">
                                <div class="form-group">
                                    <input [(ngModel)]="password" [ngModelOptions]="{standalone: true}" type="password" class="form-control" placeholder="Contraseña">
                                    <button class="btn btn-warning waves-effect btn-rounded" (click)="updatePassword()">Actualizar contraseña</button>
                                </div>
                            </div>

                            <div *ngIf="user.role!='evaluated' && user.isCustomBrand" class="col-md-6">
                              <div class="form-group">
                                <label class="control-label">Link del logo</label>
                                  <input formControlName="logoLink" type="text" class="form-control" placeholder="https://tudominio.com">
                              </div>
                            </div>

                            <div *ngIf="user.role!='evaluated' && user.isCustomBrand" class="col-md-6">
                              <div class="form-group">
                                <label class="control-label">Color principal</label>
                                  <input formControlName="customColor" type="color" class="form-control" placeholder="color">
                              </div>
                            </div>

                            <div *ngIf="user.role!='evaluated' && user.isCustomBrand" class="col-md-6">
                              <div class="form-group">
                                <label class="control-label">Logo personalizado</label>
                                  <input type="file" multiple="false" class="form-control" placeholder="Seleccionar imágen" (change)="uploadImage($event)">
                                  <p class="mb-0"><small>Soporta formatos jpg, jpeg y png hasta 2 MB</small></p>
                                  <p><small>Medida recomendada 200 x 90 px</small></p>
                              </div>
                            </div>
                            <div *ngIf="user.role!='evaluated' && user.isCustomBrand" class="col-md-6">
                              
                              <img class="custom-logo-uploaded" *ngIf="registerForm.value.logoUrl" [src]="registerForm.value.logoUrl" alt="">
                            
                            </div>
                        </div>

                        <div *ngIf="isSubscribed && !user.subscriptionCancelled" class="col-12">
                            <h5>Estás suscripto a las pruebas cognitivo - laborales. La próxima fecha de renovación es {{user.subscriptionEnd | date: 'dd/MM/yyyy'}} </h5>
                            <button class="btn btn-warning waves-effect btn-rounded" (click)="cancelSubscription()">Cancelar suscripción</button>
                        </div>
                        <div *ngIf="isSubscribed && user.subscriptionCancelled" class="col-12">
                            <h5>No estás suscripto a las pruebas cognitivo - laborales. Tendrás acceso hasta {{user.subscriptionEnd | date: 'dd/MM/yyyy'}} </h5>
                            <button class="btn btn-info waves-effect btn-rounded" [routerLink]="['/dashboard/plans']">Renovar suscripción</button>
                        </div>
                        
                    </div>
                    <div class="form-actions">
                        <!-- <button type="button" class="btn btn-success btn-rounded waves-effect" (click)="exportData()" >Exportar datos de puebas</button> -->
                        <button type="submit" class="btn btn-success btn-rounded waves-effect pull-right">Actualizar</button>

                    </div>
                </form>
            </div>
        </div>
    </div>
</div>